import { Injectable } from '@angular/core';
import { GridLayoutService } from '@irb-common/interfaces/grid-layout.service';
import { EditorQuickOrderEntryComponent } from "@irb/irb-editors/editor-quick-order-entry/editor-quick-order-entry.component";
import { DeleteCellComponent } from "@irb-common/components/grid/renderers/delete.cell.component";
import { DeleteHeaderComponent } from "@irb-common/components/grid/renderers/delete.header.component";
import { IOrders } from "@irb/irb-orders/irb-orders.model";

@Injectable({
    providedIn: 'root'
})
export class EditorQuickOrderEntryGridLayoutService implements GridLayoutService<EditorQuickOrderEntryComponent> {
    constructor() {}

    getFrameworkComponents() {
        return {
            "DeleteHeaderComponent": DeleteHeaderComponent,
            "DeleteCellComponent": DeleteCellComponent
        };
    }

    getColumnDefs(_parent: EditorQuickOrderEntryComponent) {
        return [
            {
                headerName: "Delete All",
                headerComponent: "DeleteHeaderComponent",
                headerComponentParams: { 
                    message: "Remove all Entries?", 
                    proceed: () => _parent.deleteAll(),
                    cancel: () => _parent.cancelDelete()
                },
                cellRenderer : "DeleteCellComponent",
                cellRendererParams: { 
                    message: "Remove this Entry?",
                    proceed: (t: IOrders) => _parent.delete(t),
                    cancel: () => _parent.cancelDelete()
                },
                cellClass: '',
                resizable: false,
                minWidth: 25,
                maxWidth: 25,
                width: 25
            },
            {
                headerName: 'Account',
                suppressFiltersToolPanel: true,
                field: 'accountNumber',
                colId:'accountNumber',
                cellClass: 'irb-cell-content-right',
                minWidth: 95
            },{
                headerName: 'Account Name',
                suppressFiltersToolPanel: true,
                field: 'accountName',
                colId:'accountName', 
                cellRenderer : 'cellRendererFormatter',
                minWidth: 130
            },{
                headerName: 'Symbol',
                suppressFiltersToolPanel: true,
                field: 'securitySymbol',
                colId:'securitySymbol',
                minWidth: 68,
                width:100
            },{
                headerName: 'Trans Type',
                suppressFiltersToolPanel: true,
                field: 'transactionType',
                colId:'transactionType',
                minWidth: 120
            },{
                headerName: 'Amt Type',
                suppressFiltersToolPanel: true,
                field: 'amountType',
                colId:'amountType', 
                minWidth: 75
            },{
                headerName: 'Shr Qty',
                suppressFiltersToolPanel: true,
                sortable: true,
                field: 'quantity',
                colId:'quantity',
                cellClass: 'irb-cell-content-right',
                minWidth: 90,
            },{
                headerName: 'Order Amt',
                suppressFiltersToolPanel: true,
                sortable: true,
                field: 'dollarAmount',
                colId:'dollarAmount', 
                cellRenderer : 'cellRendererFormatter',
                cellRendererParams: { type: 'currency', decimalPosition: '2' },
                minWidth: 90,
            },{
                headerName: 'Order Type',
                suppressFiltersToolPanel: true,
                field: 'orderType',
                colId:'orderType',
                minWidth: 95,
            },{
                headerName: 'Price',
                suppressFiltersToolPanel: true,
                field: 'price',
                colId:'price', 
                cellRenderer: 'cellRendererFormatter',
                cellRendererParams: (params: any) => {
                    const v = this.getPriceFormat(params);
                    return {
                        value: v,
                        type: (isNaN(v)) ? '' : 'currency', 
                        decimalPosition: '2'
                    }
                },
                cellClass: 'irb-cell-content-right',
                minWidth: 75
            },{  
                headerName: 'Expiration Type',
                suppressFiltersToolPanel: true,
                field: 'expirationType',
                colId:'expirationType', 
                minWidth: 80,
                cellRenderer: 'cellRendererFormatter'
            },{
                headerName: 'Expiration Date',
                suppressFiltersToolPanel: true,
                field: 'expirationDate',
                colId:'expirationDate', 
                minWidth: 100,
                cellRenderer: 'cellRendererFormatter',
                cellRendererParams: (params: any) => {
                    if(params.data.expirationDate) {
                        return {
                            value: params.data.expirationDate,
                            type: 'date', 
                            format: 'MM/dd/yyyy',
                        }
                    } else {
                        return {
                            value: 'n/a'
                        }
                    }
                },
            },{
                headerName: 'Trade Status',
                cellRenderer: 'cellRendererFormatter',
                suppressFiltersToolPanel: true,
                field: 'tradeStatus',
                colId:'tradeStatus', 
                minWidth: 100
            }
        ];
    }

    private getPriceFormat(params: any) {
        const defaultOrderPriceType = params.data.defaultOrderPriceType ? params.data.defaultOrderPriceType.toUpperCase() : '';

        if(params.data.orderType === "Market" ) {
            return 'M';
        } else if (params.data.orderType === "Limit" && (defaultOrderPriceType === "ASK" || defaultOrderPriceType === "BID" || defaultOrderPriceType === "LASTTRADE" || defaultOrderPriceType === "MIDPOINT")) {
            return this.getOrderPriceTypeFormat(params.data.defaultOrderPriceType) + ' $' + (params.data.ordLimitPrice.toFixed(2) ?? params.data.price.toFixed(2));
        } else if (params.data.orderType === "Stop Limit" || params.data.orderType === "STOPLIMIT") {
            const limitPrice = params.data.ordLimitPrice ?? params.data.price;
            return (limitPrice ? 'L ' + limitPrice.toFixed(2):'') + '  ' + (params.data.ordStopPrice ? 'S ' + params.data.ordStopPrice.toFixed(2): '')
        } else {
            return params.data.ordLimitPrice ?? params.data.ordStopPrice ?? params.data.price;
        }
    }

    private getOrderPriceTypeFormat(defaultOrderPriceType: string) {
        switch(defaultOrderPriceType) {
            case "ASK":
                return "Ask";
            case "BID": 
                return "Bid";
            case "LASTTRADE":
                return "Last Trade"; 
            case "MIDPOINT":
                return "Midpoint";
        }

        return defaultOrderPriceType;
    }
}
